/* DORI free-gift selector.
   Watches the cart. Once the non-gift subtotal clears the threshold the
   customer can choose a free bracelet; the line is added with the
   `_free_gift: true` property that the discount reads to make it free.
   If the subtotal drops back below the threshold the gift is removed so a
   customer is never charged for it. */
(function () {
  var root = document.getElementById('dori-gift');
  if (!root) return;

  var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 0;
  var SHIPPING = parseInt(root.getAttribute('data-shipping'), 10) || 0;
  var KEY = root.getAttribute('data-key') || '_free_gift';
  var LOCKED = root.getAttribute('data-locked-label') || 'Spend {{amount}} more for a free gift';
  var UNLOCKED = root.getAttribute('data-unlocked-label') || 'You have earned a free gift';
  var ADDED = root.getAttribute('data-added-label') || 'Your free gift is in the bag';
  var SHIP_LOCKED = root.getAttribute('data-ship-locked-label') || 'Spend {{amount}} more for free shipping';
  var SHIP_UNLOCKED = root.getAttribute('data-ship-unlocked-label') || 'Shipping is free';
  var CAP_SHIP = root.getAttribute('data-cap-shipping') || 'Free shipping';
  var CAP_GIFT = root.getAttribute('data-cap-gift') || 'Free bracelet';

  var busy = false;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.theme_money_format) {
      return Shopify.formatMoney(cents, window.theme_money_format);
    }
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function isGift(item) {
    return item.properties && String(item.properties[KEY]) === 'true';
  }

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function nonGiftSubtotal(cart) {
    return cart.items.reduce(function (sum, it) { return isGift(it) ? sum : sum + it.final_line_price; }, 0);
  }
  function giftLine(cart) {
    for (var i = 0; i < cart.items.length; i++) { if (isGift(cart.items[i])) return cart.items[i]; }
    return null;
  }

  function openModal() {
    // Portal to <body>: inside #root the theme's transparent panel overlay
    // (overlay-close) stacks above the modal and swallows every click.
    if (root.parentElement !== document.body) document.body.appendChild(root);
    // Close the theme drawer first: while any panel is open, its full-screen
    // click-catcher intercepts pointer events meant for the modal. The
    // post-add refresh reopens the drawer with fresh contents.
    if (document.documentElement.classList.contains('m6pn-open')) {
      var closer = document.querySelector('#cart .m6pn-close') || document.querySelector('.m6pn-close');
      if (closer) closer.click();
    }
    root.hidden = false;
    // This theme scrolls <html>, not <body>: lock both.
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }
  function closeModal() { root.hidden = true; document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }

  function addGift(variantId, btn) {
    if (busy) return; busy = true;
    setTimeout(function () { busy = false; }, 8000); // never leave the picker dead
    var cta = btn ? btn.querySelector('.dori-gift__cta') : null;
    if (btn) { btn.classList.add('is-busy'); if (cta) cta.textContent = 'Adding…'; }
    var props = {}; props[KEY] = 'true';
    // One free bracelet per order: if a gift line already exists, don't add
    // another (the discount only zeroes one anyway).
    getCart().then(function (cart) {
      if (giftLine(cart)) {
        closeModal();
        if (btn) btn.classList.remove('is-busy');
        return refreshDrawer(true);
      }
      return doAdd();
    });
    function doAdd() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      if (cta) cta.textContent = 'Added ✓';
      closeModal();
      return refreshDrawer(true);
    }).catch(function () {
      busy = false;
      if (btn) btn.classList.remove('is-busy');
      if (cta) cta.textContent = 'Try again';
    });
    }
  }

  function removeGift(key) {
    if (busy) return; busy = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { return refreshDrawer(false); }).catch(function () { busy = false; });
  }

  // Fully ajax: re-render the drawer through the theme's own section
  // (side-cart, the same endpoint its updateCartPanel uses), then cycle the
  // panel so the theme re-runs its open choreography on the fresh nodes.
  var refreshing = false;
  function refreshDrawer(ensureOpen) {
    if (refreshing) return Promise.resolve();
    refreshing = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + '?section_id=side-cart')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The section endpoint returns the drawer's INNER content wrapped in
        // #shopify-section-side-cart; the live aside#cart holds that content
        // directly. Pair them accordingly.
        var fresh = doc.querySelector('#shopify-section-side-cart') || doc.getElementById('cart');
        var liveCart = document.getElementById('cart');
        if (fresh && liveCart) liveCart.innerHTML = fresh.innerHTML;
        // Cart page: swap its form container too (same ajax, no reload).
        var pageForm = document.querySelector('.template-cart form.form-cart');
        if (pageForm) {
          fetch(window.location.href, { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (pageHtml) {
              var pdoc = new DOMParser().parseFromString(pageHtml, 'text/html');
              var freshForm = pdoc.querySelector('form.form-cart');
              if (freshForm) pageForm.parentElement.replaceChild(freshForm, pageForm);
              render();
            }).catch(function () {});
        }
        var opener = document.querySelector('a[data-panel="cart"]');
        var isOpen = document.documentElement.classList.contains('m6pn-open');
        if (opener && ensureOpen) {
          // Close + reopen so the theme applies its reveal states to the
          // swapped content (a straight swap leaves it invisible).
          if (isOpen) { opener.click(); setTimeout(function () { opener.click(); }, 120); }
          else { opener.click(); }
        }
      })
      .catch(function () {})
      .then(function () { refreshing = false; busy = false; setTimeout(render, 300); });
  }

  function bar(sub) {
    var pct = Math.max(3, Math.min(100, Math.round((sub / THRESHOLD) * 100)));
    var hasShip = SHIPPING > 0 && SHIPPING < THRESHOLD;
    var shipPct = hasShip ? Math.round((SHIPPING / THRESHOLD) * 100) : 0;
    var html = '<div class="dori-gift-bar"><span style="width:' + pct + '%"></span>';
    if (hasShip) html += '<i class="' + (sub >= SHIPPING ? 'done' : '') + '" style="left:' + shipPct + '%"></i>';
    html += '<i class="' + (sub >= THRESHOLD ? 'done' : '') + '" style="left:100%"></i></div>';
    html += '<div class="dori-gift-caps">';
    if (hasShip) html += '<span class="' + (sub >= SHIPPING ? 'done' : '') + '" style="left:' + shipPct + '%">' + CAP_SHIP + '</span>';
    html += '<span class="' + (sub >= THRESHOLD ? 'done' : '') + '">' + CAP_GIFT + '</span></div>';
    return html;
  }


  var TRUCK_SVG = '<svg width="20" height="16" viewBox="0 0 24 18" fill="none" aria-hidden="true"><path d="M1 1h13v12H1zM14 5h5l4 4v4h-9" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><circle cx="5.5" cy="15.5" r="2" stroke="currentColor" stroke-width="1.4"/><circle cx="17.5" cy="15.5" r="2" stroke="currentColor" stroke-width="1.4"/></svg>';
  function cutoffLeft() {
    var now = new Date(); var cut = new Date(now); cut.setHours(23, 30, 0, 0);
    if (now > cut) cut.setDate(cut.getDate() + 1);
    var diff = cut - now;
    return Math.floor(diff / 3600000) + 'h ' + (Math.floor(diff / 60000) % 60) + 'm';
  }
  function placeCheckoutExtras() {
    var btns = Array.prototype.slice.call(document.querySelectorAll('#cart .overlay-buy_button')).filter(function (b) {
      return !b.closest('.cart-upsell') && !b.closest('.product-card');
    });
    if (!btns.length) return;
    document.querySelectorAll('[data-dori-cd]').forEach(function (n) { n.remove(); });
    var first = btns[0], last = btns[btns.length - 1];
    var d = document.createElement('p');
    d.className = 'dori-cd-line'; d.setAttribute('data-dori-cd', '');
    d.innerHTML = TRUCK_SVG + '<span>Order within <b data-dori-cutoff>' + cutoffLeft() + '</b>, <b>delivered tomorrow</b></span>';
    first.parentNode.insertBefore(d, first);
    var k = document.createElement('p');
    k.className = 'dori-cd-klarna'; k.setAttribute('data-dori-cd', '');
    k.innerHTML = 'Pay later or in 3 instalments with <b class="dori-klarna-chip">Klarna.</b>';
    last.parentNode.insertBefore(k, last.nextSibling);
    // Payment marks: clone the footer's curated row so the drawer always
    // shows the identical set, one row.
    var footerPay = document.querySelector('.dori-footer__pay');
    if (footerPay) {
      var pay = footerPay.cloneNode(true);
      pay.className = 'dori-cd-pay';
      pay.setAttribute('data-dori-cd', '');
      k.parentNode.insertBefore(pay, k.nextSibling);
    }
  }
  setInterval(function () {
    document.querySelectorAll('[data-dori-cutoff]').forEach(function (el) { el.textContent = cutoffLeft(); });
  }, 30000);

  function banner(state, amountLeft, sub) {
    var b = document.createElement('div');
    b.className = 'dori-gift-banner';
    b.setAttribute('data-dori-gift-banner', '');
    if (state === 'locked') {
      var label;
      if (SHIPPING > 0 && sub < SHIPPING) {
        label = SHIP_LOCKED.replace('{{amount}}', '<b>' + money(SHIPPING - sub) + '</b>');
      } else if (SHIPPING > 0) {
        label = SHIP_UNLOCKED + ' &middot; ' + LOCKED.replace('{{amount}}', '<b>' + money(amountLeft) + '</b>');
      } else {
        label = LOCKED.replace('{{amount}}', '<b>' + money(amountLeft) + '</b>');
      }
      b.innerHTML = '<p class="dori-gift-banner__label">' + label + '</p>' + bar(sub);
    } else if (state === 'unlocked') {
      b.innerHTML = '<p class="dori-gift-banner__label"><b>' + UNLOCKED + '.</b></p>' +
        '<button type="button" class="dori-gift-banner__btn" data-gift-open>Choose your bracelet</button>' + bar(sub);
    } else {
      b.innerHTML = '<p class="dori-gift-banner__label"><b>' + ADDED + '.</b></p>' + bar(sub);
    }
    return b;
  }

  function placeBanner(node) {
    document.querySelectorAll('[data-dori-gift-banner]').forEach(function (n) { n.remove(); });
    // Cart drawer first, then cart-page form.
    var drawer = document.querySelector('#cart .l4ca') || document.querySelector('#cart');
    var page = document.querySelector('.template-cart .l4ca') || document.querySelector('.template-cart form[action*="/cart"]');
    [drawer, page].forEach(function (target) {
      if (target && target.offsetParent !== null) { target.parentNode.insertBefore(node.cloneNode(true), target); }
    });
  }

  function render() {
    getCart().then(function (cart) {
      var sub = nonGiftSubtotal(cart);
      var gift = giftLine(cart);
      // Below threshold but a gift is in the bag: pull it so nobody pays for it.
      if (gift && sub < THRESHOLD) { removeGift(gift.key); return; }
      var node;
      if (gift && sub >= THRESHOLD) node = banner('added', 0, sub);
      else if (sub >= THRESHOLD) node = banner('unlocked', 0, sub);
      else if (sub > 0) node = banner('locked', THRESHOLD - sub, sub);
      if (node) placeBanner(node);
      placeCheckoutExtras();
      // Shopify tags every buys-side item with the BxGy label at (-EUR 0,00);
      // only the actual gift line's tag is meaningful. Hide the zero ones.
      document.querySelectorAll('#cart p.overlay-gray, .template-cart p.overlay-gray').forEach(function (tag) {
        if (/\(\s*-\s*[^0-9]*0([,.]00)?\s*\)/.test(tag.textContent)) { tag.style.display = 'none'; return; }
        // The free-gift line should read as a plain perk, not accounting:
        // "FREE BRACELET (-€20,00)" -> "FREE BRACELET".
        if (/free bracelet/i.test(tag.textContent)) {
          tag.childNodes.forEach(function (n) {
            if (n.nodeType === 3) n.textContent = n.textContent.replace(/free bracelet[^(]*/i, 'FREE BRACELET ').replace(/\(\s*-[^)]*\)/, '');
          });
        }
      });
    });
  }

  // Collection/carousel cards: move the quick-buy form into the figure so
  // the disc anchors to the image, not the theme's computed overlay slot.
  function dockQuickBuys() {
    document.querySelectorAll('.l4cl .product-card form.f8pr.form-card').forEach(function (f) {
      var fig = f.closest('.product-card').querySelector('figure');
      if (fig && f.parentElement !== fig) fig.appendChild(f);
    });
  }
  dockQuickBuys();
  if ('MutationObserver' in window) {
    new MutationObserver(function () { dockQuickBuys(); }).observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-gift-add]');
    if (add) { e.preventDefault(); addGift(add.getAttribute('data-gift-add'), add); return; }
    if (e.target.closest('[data-gift-open]')) { e.preventDefault(); openModal(); return; }
    if (e.target.closest('[data-gift-close]')) { e.preventDefault(); closeModal(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) closeModal(); });

  // Render now and whenever the theme mutates the cart (drawer open, ajax add).
  render();
  ['ajaxCart', 'cart:updated', 'cart:refresh'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(render, 300); }); });
  var cartEl = document.getElementById('cart');
  if (cartEl && 'MutationObserver' in window) {
    new MutationObserver(function () { setTimeout(render, 200); }).observe(cartEl, { childList: true, subtree: false });
  }
})();
